module.exports = __webpack_public_path__ + "static/media/news_feed.28be99f0.svg";